import { render, staticRenderFns } from "./LocationCatalog.vue?vue&type=template&id=50e2a2c4&scoped=true"
import script from "./LocationCatalog.vue?vue&type=script&lang=js"
export * from "./LocationCatalog.vue?vue&type=script&lang=js"
import style0 from "./LocationCatalog.vue?vue&type=style&index=0&id=50e2a2c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2a2c4",
  null
  
)

export default component.exports